import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./sales-return-initial";

const salesReturnSlice = createSlice({
  name: "salesReturn",
  initialState,
  reducers: {
    onLoading(state, action) {
      state.isLoading[action.payload] = true;
    },
    rejectedActions(state, action) {
      state.isLoading[action.payload.name] = false;
      state.error = action.payload;
    },
    loadedAllSalesReturns(state, action) {
      state.allSalesReturns = action.payload;
      state.isLoading.allSalesReturns = false;
    },
    loadedAllSalesReturnsExport(state, action) {
      state.allSalesReturnsExport = action.payload;
      state.isLoading.allSalesReturns = false;
    },
    loadedApprovalList(state, action) {
      const { approvalTemplates, approvalProgress } = action.payload;
      const sortedApprovalTemplates = approvalTemplates.sort(
        (a, b) => a.step_number - b.step_number
      );

      const progressList =
        (approvalProgress && approvalProgress.length > 0 && approvalProgress) ||
        [];

      let formatApprovalList = [];
      sortedApprovalTemplates.forEach((approvalTemplate) => {
        if (approvalTemplate.is_required_approve) {
          const matchedProgress = progressList.find(
            (progress) => progress.step_number === approvalTemplate.step_number
          );
          const formatApprovalWithStatus = {
            id: approvalTemplate.id,
            step_number: approvalTemplate.step_number,
            reviewer_list: approvalTemplate.reviewer_list,
            approval_status:
              (matchedProgress && matchedProgress.approval_status) || null,
            created_date:
              (matchedProgress && matchedProgress.created_date) || null,
            approved_by:
              (matchedProgress &&
                approvalTemplate.reviewer_list.find(
                  (approve) =>
                    approve.document_id ===
                    matchedProgress.approved_by_document_id
                )) ||
              (matchedProgress && matchedProgress.approved_by) ||
              null,
          };
          formatApprovalList.push(formatApprovalWithStatus);
        }
      });

      state.approvalList = formatApprovalList;
    },
    loadedSalesReturn(state, action) {
      state.salesReturn = action.payload;
      state.isLoading.salesReturn = false;
    },
    loadedSalesOrderItem(state, action) {
      state.salesOrderItemList = action.payload;
    },
    loadedCreditNoteTab(state, action) {
      state.creditNoteTab = action.payload;
      state.isLoading.salesReturn = false;
    },
    loadedGoodReceiveTab(state, action) {
      state.goodReceiveTab = action.payload;
      state.isLoading.salesReturn = false;
    },
    updateSalesReturnStatus(state, action) {
      state.salesReturn.render_status = action.payload;
      state.isLoading.salesReturn = false;
    },
    updateApprovalStatus(state, action) {
      const { approval_list, user } = action.payload;

      const progressList =
        (approval_list && approval_list.length > 0 && approval_list) || [];

      const isHaveApproval =
        progressList.length > 0 &&
        progressList.every(
          (approval) =>
            approval?.approval_template &&
            approval?.approval_template?.is_required_approve === true
        );

      const foundWaitApprove = progressList
        .filter((approval) => approval?.approval_status === "PENDING")
        .sort((a, b) => a.step_number - b.step_number)[0];

      const isHaveApprovalPermission =
        foundWaitApprove &&
        foundWaitApprove?.approval_template?.reviewer_document_id_list?.includes(
          user.document_id
        );

      state.isHaveApprovalPermission = isHaveApprovalPermission;
      state.isHaveApproval = isHaveApproval;

      progressList.forEach((approval) => {
        const target = state.approvalList.find(
          (item) => item.step_number === approval.step_number
        );
        if (target) {
          target.approval_status = approval.approval_status;
        }
      });
    },
    resetAllSalesReturns(state) {
      state.allSalesReturns = initialState.allSalesReturns;
      state.error = initialState.error;
    },
    resetAllSalesReturnsExport(state) {
      state.allSalesReturnsExport = initialState.allSalesReturnsExport;
      state.error = initialState.error;
    },
    resetGoodReceiveTab(state) {
      state.goodReceiveTab = initialState.goodReceiveTab;
      state.error = initialState.error;
    },
    resetSalesReturn(state) {
      state.salesReturn = initialState.salesReturn;
      state.creditNoteTab = initialState.creditNoteTab;
      state.goodReceiveTab = initialState.goodReceiveTab;
      state.error = initialState.error;
    },
    resetSalesReturnError(state) {
      state.error = initialState.error;
    },
  },
});

export const salesReturnActions = salesReturnSlice.actions;

export default salesReturnSlice.reducer;
